<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    :loading="loading"
    @change="handleChange"
    :placeholder="multiple ? '可多选' : '按角色查找人员'"
    style="width: 100%"
    :multiple="multiple"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { roleList } from '@/service/getData'

export default {
  props: {
    value: '',
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: [],
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      this.loading = true
      let res = await roleList()
      this.lists = res.data.list.filter((item) => item.status == 1)
      this.loading = false
    },
  },
}
</script>